import { render, staticRenderFns } from "./DrawerToolbar.vue?vue&type=template&id=54a9f6ac"
import script from "./DrawerToolbar.vue?vue&type=script&lang=js"
export * from "./DrawerToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports